import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Slider({article}) {
    return (
        <section className="jumbotmod text-center container mt-45">
        <div id="carouselExampleFade" className="carousel slide carousel-fade" data-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
            <LazyLoadImage
                            src={article.pathToImage}
                            className="d-block slide"
                            style={{width:"100%",height:"300px"}}
                            alt="..."
                        >
             </LazyLoadImage>
            </div>
      
        </div>
        
        </div>
      </section>
    );

}


export default Slider;






/*
  <main role="main mt-45">

      <section class="jumbotmod text-center container mt-45">
        <div id="carouselExampleFade" class="carousel slide carousel-fade" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img src="img/missions.png" style="height: 300px;" class="d-block" alt="...">
            </div>
            <div class="carousel-item">
              <img src="img/mission.png" style="height: 300px;" class="d-block" alt="...">
            </div>
          <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </section>

      <div class="container">
        <div class="card">
          <div class="row no-gutters">
           
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade card-body show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <h5 class="card-title">Hotel de l'Aeroport</h5>
                <p class="card-text">
                  Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                  pour des escapades à Brazzaville. Si summis magna non proident ex voluptate a nulla, veniam mentitum proident.
                </p>
                <p>
                  Eu fore voluptatibus eu quem comprehenderit possumus quorum laboris se aliquip aut
                  minim sed ingeniis ut veniam ad officia cillum esse commodo dolor Non anim elit
                  a officia, an aliqua possumus te voluptate.
                </p>
                <hr>
                <p class="card-text">
                  <i class="fa blue fa-location-arrow mr-2"></i> Moungali, Brazzaville
                </p>
                <hr>
                <ul class="pagination pagination-sm">
                  <li class="page-item">
                    <a class="page-link" href="#">
                      <i class="fa blue fa-street-view mr-2"></i> 300 m de votre position (voir la carte)
                    </a>
                  </li>
                </ul>
               
                <hr>
                <ul class="pagination pagination-sm">
                  <li class="page-item">
                    <a class="page-link" href="#">
                      <i class="fa blue fa-mobile mr-2"></i><span>+242 06 666 66 66</span>
                    </a>
                  </li>
                </ul>
                <hr>
                <p>
                  <a href="#"><i class="fa blue fa-home mr-2"></i></a>
                  <span>45 avenue Nelson, Mandela <br> 37382 Moungali, Brazzaville</span>
                </p>
                <hr>
                <p>
                  <a href="#"><i class="fa blue fa-home mr-2"></i></a>
                  <span>En diagnale de la mairie de Poto-poto</span>
                </p>
                <hr>
                
                <a href="#" class="btn btn-primary">Appeler</a>
              </div>
              
            </div>
          </div>
        </div>
      </div>

    </main>
*/